module.exports = __webpack_public_path__ + "static/media/25.c87af291.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/25.png
// module id = 1066
// module chunks = 0